import React, { useState } from "react";
import { Header } from "./header/Header";
import { Outlet } from "react-router";
import GetLogsEvent from "../service/utilite/GetLogsEvent";
import { observer } from "mobx-react-lite";
import media from "../service/state/media";
import HeaderMobile from "./header/HeaderMobile";
import MobileNav from "./header/MobileNav";
import RandomLogs from "./debug_components/_RandomLogs";
import debugComponent from "../service/state/debug.component";
import { KeyboardController } from "../service/utilite/KeyboardController";

export const Layout = observer(() => {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <div className="layout_container">
      <KeyboardController />
      {/* {debugComponent.random_log ? <RandomLogs /> : <></>} */}
      {/* <GetLogsEvent /> */}
      {!media.mobile ? (
        <Header />
      ) : (
        <HeaderMobile menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      )}
      <div className="container_page">
        {media.mobile && menuOpen ? (
          <MobileNav menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
        ) : (
          <Outlet />
        )}
      </div>
    </div>
  );
});
